<template>
  <div>
    <div style="width: 100px;flex-shrink: 0;" class="c-profile-lf-txt">专业领域</div>
    <div class="c-profile-rt-input">
      <el-checkbox-group v-model="orgCategories" @change="handleIndustrycategoryChange">
        <el-checkbox v-for="category,index in industrycategories.wisdom.list" :label="category" :key="category" :ref="'sv'+index"
          :id="'sv'+index" @change="selectOne(...['sv'+index,index])">{{category}}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
  import {
    Checkbox,
    CheckboxGroup
  } from 'element-ui';

  export default {
    name: 'OrgType',
    components: {
      [Checkbox.name]: Checkbox,
      [CheckboxGroup.name]: CheckboxGroup,
    },
    props: {
      selectedOptions: {
        type: String
      }
    },
    watch: {
      selectedOptions(n, o) {
        console.log("selectedOptions--n=", n, "o=", o)
        this.handleSelectedOptionsProps(n);
      }
    },
    data() {
      return {
        industrycategories: {
          wisdom: {
            name: '专业领域',
            list: ['新基建', '数字上云', '智慧专区', '金融机构']
          },
        },
        checkAll: false,
        orgCategories: [],
        showEditor:false,
        other:""
      }
    },
    methods: {
      selectOne(ref,index) {
        this.orgCategories.splice(0, this.orgCategories.length)
        var cur = this.$refs[ref]
        var curname = cur[0].label
        this.orgCategories.push(curname)
        if(index===this.orgCategories.length-1){
          this.showEditor=true
        }else{
          this.showEditor=false
        }
      },
      handleSelectedOptionsProps(v) {
        if (v) {
          const options = v.split(';');
          this.orgCategories = this.industrycategories.wisdom.list.filter((item) => {
            return options.includes(item);
          }) || [];
          // this.handleCheckAll();
        }
      },
      // handleCheckAllChange(val) {
      //   this.orgCategories = val ? this.industrycategories.wisdom.list : [];
      //   this.checkAll1 = val;
      // },
      // handleCheckAll() {
      //   const checked = this.orgCategories.length;
      //   const total = this.industrycategories.wisdom.list.length;
      //   this.checkAll = checked === total;
      //   this.emitData();
      // },
      handleIndustrycategoryChange(value) {
        // this.checkAll1 = value.length === this.industrycategories.wisdom.list.length;
        // this.handleCheckAll();
      },
      getCheckedCategories() {
        return this.orgCategories;
      },
      emitData() {
        this.$emit('dataChange', this.getCheckedCategories());
      }
    }
  }
</script>

<style>
</style>
